module.exports = __webpack_public_path__ + "img/server04.d930e66d.jpg";